import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';

const loginRoutes: Routes = [ { path: '', component: LoginComponent, data: { title: 'Login' } } ];

export const loginRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(loginRoutes);
